import StorageFn from '@/utils/electronStorage';
import Fn from '@/utils/fn';
import {
  LEGEND_ID,
  LEGENDARY_ID,
  LEGEND_THREE_ID,
  LEGEND_PC_ONLY_ID,
  prefectures
} from '@/components/ElectronLayout/ElectronHead/config';
import { apiGetTimeSection, timeSechionJson } from '../server';
import { SHOW_VERSION } from './config';
import { onOpenServerCollect, openServerCollect } from '@/config/collect/openServerCollect';
import { GameItemJson } from './server';

/**
 * 检查是否处于特殊专区：(传3 | 纯PC)
 */
export const checkSpecialZone = () => {
  const id = Number(localStorage.getItem('NAV_TABBTN_ID') ?? LEGEND_ID);
  return id === LEGEND_THREE_ID || id === LEGEND_PC_ONLY_ID;
};

/**
 * 获取专区名称
 */
export const getSpecialZoneName = () => {
  const id = Number(localStorage.getItem('NAV_TABBTN_ID') ?? LEGEND_ID);
  return prefectures.find(item => item.id === id)?.label;
};

/**
 * 获取当前时间段标识
 */
export const getCurrentTimeSectionKey = () => {
  const now = new Date();
  const hour = now.getHours();
  const minute = now.getMinutes();

  const startLimit = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime();
  const endLimit = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 7, 0, 0, 0).getTime();

  if (now.getTime() >= startLimit && now.getTime() < endLimit) {
    return '通宵推荐';
  }

  const mm = minute < 30 ? '00' : '30';
  const hh = hour.toString().padStart(2, '0');
  return `${hh}:${mm}`;
};

const LOCAL_KEY = 'BASE_HOME_OPEN_SERVER_LIST_SECTIONS';

const fetchAndCacheSections = async () => {
  try {
    const { data } = await apiGetTimeSection();
    const arr = Array.isArray(data?.time_section) ? data.time_section : [];
    await StorageFn.electronSetData(LOCAL_KEY, JSON.stringify(arr));
    return arr;
  } catch (error) {
    console.error('apiGetTimeSection error:', error);
    return [];
  }
};

export const getSections = async () => {
  try {
    const content = await StorageFn.electronGetData(LOCAL_KEY);
    if (content) {
      const parsedData = JSON.parse(content as string);
      if (Array.isArray(parsedData)) return parsedData as timeSechionJson[];
    }
  } catch (error) {
    console.error('getSections error:', error);
  }

  return fetchAndCacheSections();
};

export const clearElectronLocalData = async () => {
  try {
    await StorageFn.electronDelData(LOCAL_KEY);
  } catch (error) {
    console.error('getSections error:', error);
  }
};

const checkWhiteListPrefecture = () => {
  const localId = localStorage.getItem('NAV_TABBTN_ID');
  const oldId = localId ? Number(localId) : 0;
  const arr = [LEGEND_ID, LEGENDARY_ID, LEGEND_THREE_ID, LEGEND_PC_ONLY_ID];
  return arr.includes(oldId);
};

export const showNewOpenList = () => {
  if (!checkWhiteListPrefecture()) return false;

  const currentVersion = Fn.getBoxVersion();
  return currentVersion >= SHOW_VERSION;
};

interface GQSJson {
  trackinfo?: string;
  trackid?: string;
  requestid?: string;
  gqs?: string;
}

const homeReportStrategy = async (item: GameItemJson, index: number, obj?: GQSJson) => {
  await openServerCollect(index + 1, 3, obj);
  await onOpenServerCollect(504, { game_id: item.gameId, game_name: item.gameName, ...obj });
};

const specialGameReportStrategy = async (item: GameItemJson, index: number, obj?: GQSJson) => {
  await openServerCollect(index + 1, 2, obj);
  await onOpenServerCollect(762, {
    game_id: item.gameId,
    game_name: item.gameName,
    data_id: item.gameId,
    ...obj
  });
};

const normalGameReportStrategy = async (item: GameItemJson, index: number, obj?: GQSJson) => {
  await openServerCollect(index + 1, 1, obj);
  await onOpenServerCollect(731, { game_id: item.gameId, game_name: item.gameName, ...obj });
};

/**
 * 进入游戏详情页 - 上报策略
 */
export const reportStrategy = async (homeFlag: boolean, item: GameItemJson, index: number, obj?: GQSJson) => {
  const boxGameId = item.gameId;

  if (homeFlag) {
    await homeReportStrategy(item, index, obj);
  } else if (boxGameId && boxGameId >= 10000 && boxGameId < 20000) {
    await specialGameReportStrategy(item, index, obj);
  } else {
    await normalGameReportStrategy(item, index, obj);
  }
};
